import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInputClass;
function GrantDiscordAccessInput() {
  if (GrantDiscordAccessInputClass === VOID) {
    class $ {
      constructor(code, partyId, guildId) {
        this.y6p_1 = code;
        this.z6p_1 = partyId;
        this.a6q_1 = guildId;
      }
      toString() {
        return 'GrantDiscordAccessInput(code=' + this.y6p_1 + ', partyId=' + this.z6p_1.toString() + ', guildId=' + this.a6q_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.y6p_1);
        result = imul(result, 31) + this.z6p_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.a6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessInput()))
          return false;
        if (!(this.y6p_1 === other.y6p_1))
          return false;
        if (!this.z6p_1.equals(other.z6p_1))
          return false;
        if (!(this.a6q_1 === other.a6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessInput');
    GrantDiscordAccessInputClass = $;
  }
  return GrantDiscordAccessInputClass;
}
//region block: exports
export {
  GrantDiscordAccessInput as GrantDiscordAccessInputqu7hxtlblgwv,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput.mjs.map
